import { useQuery } from "react-query";
import { axios } from "../../lib/axios";
import { onError } from "./onError";

export function useQuestionCategoryQuery({ orgId, onSuccess }) {
  return useQuery(
    ["category-list", orgId], 
    async () => {
      const res = await axios.get(`/question/category?orgId=${orgId}`);
      return res.data;
    },
    {
      enabled: !!orgId,
      keepPreviousData: true,
      onSuccess,
      onError
    }
  );
}